export const TOTAL_RETRY_CREATE_ORDER = 4;
